import { IExtendedTag } from '@/interfaces/cars.interfaces';

interface Marker {
  key: string;
  label: string;
  description: string;
  color?: string;
  borderColor?: string;
  backgroundColor?: string;
}

/**
 * Маппинг тегов в тип маркеров, для отображения.
 * @returns
 */
const mapTagsToMarkers = (tags: Array<Omit<IExtendedTag, 'collection_id'>>): Marker[] =>
  tags.reduce<Marker[]>((acc, tag) => {
    if (tag.displayName && tag.displayName.length) {
      acc.push({
        key: tag.id,
        label: tag.displayName,
        description: tag.description || tag.displayName,
        color: tag.fontColor,
        borderColor: tag.borderColor,
        backgroundColor: tag.backgroundColor,
      });
    }
    return acc;
  }, []);

export default mapTagsToMarkers;
